const TenantsTab = () => {
  return <div>TenantsTab</div>;
};

export default TenantsTab;
